import React from 'react'
import styled from 'styled-components';
import {InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import ProgressBar from './ProgressBar';
import SmallTitle from '../Components/SmallTitle';
import CheckIcon from '@material-ui/icons/Check';

function Skills() {
    const school = <CheckIcon />
    return (
        <SkillsStyled>
                <div className="small-title">
                    <SmallTitle icon={school} title={'Skills'} />
                </div>
                <InnerLayout>
                    <div className="skills">
                        <ProgressBar
                            title={'REACT JS'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'ANGULAR JS'}
                            width={'85%'}
                            text={'85%'}
                        />
                        <ProgressBar
                            title={'EXPRESS JS'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'NODE JS'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'REDUX JS'}
                            width={'95%'}
                            text={'95%'}
                        />
                        <ProgressBar
                            title={'TYPESCRIPT'}
                            width={'80%'}
                            text={'80%'}
                        />
                        <ProgressBar
                            title={'REACT-NATIVE'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'FIREBASE'}
                            width={'95%'}
                            text={'95%'}
                        />
                        <ProgressBar
                            title={'MYSQL'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'MONGODB'}
                            width={'85%'}
                            text={'85%'}
                        />
                        <ProgressBar
                            title={'BOOTSTRAP, CSS'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'GOLANG'}
                            width={'70%'}
                            text={'70%'}
                        />
                        <ProgressBar
                            title={'REST-API'}
                            width={'95%'}
                            text={'95%'}
                        />
                        <ProgressBar
                            title={'PYTHON'}
                            width={'100%'}
                            text={'100%'}
                        />
                        <ProgressBar
                            title={'JAVA'}
                            width={'90%'}
                            text={'90%'}
                        />
                        <ProgressBar
                            title={'C++, C'}
                            width={'90%'}
                            text={'90%'}
                        />
                    </div>
                </InnerLayout>
        </SkillsStyled>
    )
}

const SkillsStyled = styled.section`
    .skills{
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-row-gap: 2rem;
        grid-column-gap: 3rem;
        @media screen and (max-width: 700px){
            grid-template-columns: repeat(1, 1fr);
            padding: 40px;
        }
    }
`;

export default Skills;
